import {COMMON_LOAD_INITIAL_DATA, COMMON_LOAD_INITIAL_DATA_SUCCESS, COMMON_LOAD_INITIAL_DATA_FAILED} from './available'
import _ from 'lodash'
import {RequestState} from "../../requestState";

export default {
  [COMMON_LOAD_INITIAL_DATA](state) {
    state.fetchInitDataRequestState = RequestState.Loading;
  },
  [COMMON_LOAD_INITIAL_DATA_SUCCESS](state, initialData) {
    state.fetchInitDataRequestState = RequestState.Success;

    const availableServiceGroups = _.get(initialData, 'availableServiceGroups', []);
    const availableServices = _.get(initialData, 'availableServices', []);
    const availableClients = _.get(initialData, 'availableClients', []);
    const servicesByClients = _.get(initialData, 'servicesByClients', []);
    const availableContractors = _.get(initialData, 'availableContractors', []);
    const availableContractorMaterials = _.get(initialData, 'availableContractorMaterials', []);
    const availableLaboratories = _.get(initialData, 'availableLaboratories', []);
    const availableReactions = _.get(initialData, 'availableReactions', []);
    const availableStains = _.get(initialData, 'availableStains', []);
    const availableSlideService = _.get(initialData, 'availableSlideService', []);

    state.availableServiceGroups = availableServiceGroups;
    state.availableServices = availableServices;
    state.availableClients = availableClients;
    state.servicesByClients = servicesByClients;
    state.availableContractors = availableContractors;
    state.availableContractorMaterials = availableContractorMaterials;
    state.availableLaboratories = availableLaboratories;
    state.availableReactions = availableReactions;
    state.availableStains = availableStains;
    state.availableSlideService = availableSlideService;

    state.availableColorSchemesByColor = _.keyBy(state.availableColorSchemes, 'color')
  },
  [COMMON_LOAD_INITIAL_DATA_FAILED](state, error) {
    state.fetchInitDataRequestState = RequestState.Failed;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/common.js